import styled from 'styled-components';

import * as text from '@/components/general/TextStyles';

interface ILabel {
  $show?: boolean;
}

interface IInputBox extends ILabel {
  hide?: boolean;
}

export const InputBox = styled.div<IInputBox>`
  display: ${(props: IInputBox) => (props.hide ? 'none' : 'block')};
  position: relative;
  margin-bottom: ${(props: IInputBox) => (props.$show ? '20px' : '25px')};
  width: 100%;
  font-weight: ${(props) => props.theme.weights.regular};

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    width: 100%;
  }
`;

export const Label = styled.label<ILabel>`
  ${text.FS17_NOT_CHANGE}
  position: static;
  padding: 0;
  z-index: 1;
  display: ${(props: ILabel) => (props.$show ? 'block' : 'none')};
`;

export const Input = styled.input<IInputBox>`
  ${text.FS17_NOT_CHANGE}
  position: relative;
  z-index: 2;
  padding: 15px;
  border: 1px solid ${(props) => props.theme.colors.borderColor};
  border-radius: 16px;
  width: 100%;
  margin-top: ${(props: ILabel) => (props.$show ? '5px' : '0')};

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    padding: 12px;
  }
`;

export const IconBox = styled.div<{ color: string }>`
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 2;
  cursor: pointer;

  & svg path {
    fill: ${(props) => props.color}!important;
  }
`;
